import { Component, OnInit } from '@angular/core';
import { GaService } from '../../core/helpers/ga.service';


@Component({
  selector: 'loyaltic-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {

  constructor(private gaService: GaService,
    ) { }

  ngOnInit() {
  }

  onSubmit(form) {
    this.gaService.emitEvent('receipt_upload', 'Upload Receipt');
  }

}
